const doc = [({"en":({"adminConstantUserType":({"common":"Official site group membership", "company":"{{company}} exclusive membership"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;